import { AutogenLayoutTableLeave } from "./autogen/AutogenLayoutTableLeave";
import { ClickEvent, DataSourceMode, TableRow } from "@mcleod/components";
import { LeaveHistory, LeaveSlideoutProps } from "./LeaveHistory";
import { ModelRow, Navigation } from "@mcleod/core";

export class TableLeave extends AutogenLayoutTableLeave {
    public showSlideout = (props: LeaveSlideoutProps) => {};
    tableRowOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;

        this.showSlideout({
            leaveRow: tableRow.data,
            mode: DataSourceMode.UPDATE,
            onClose: (newLeave: ModelRow, balanceRow: ModelRow, postMade: boolean) => {
                if (postMade) {
                    this.mainDataSource.search(this.mainDataSource.lastSearch);
                }
            }
        });

    }
}
